/**
 * @desc Yung-创建字典信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  body: defs.basics.BaseDictionaryCreateDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/dataDictionary/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
